import { getUserInfo, login as loginRequest, logout, getUserMenus } from "@/api/user/user"
import { setAccessToken, removeAccessToken, getAccessToken, setAppAccessToken, removeAppAccessToken, getAppAccessToken } from "@/utils/auth"
import { addRoutes } from '@/utils/routerUtil'
import router, { resetRouter } from '@/router'

export default {
  state: {
    id: null,
    name: null,
    nameEn: null,
    userType: '0',    // 0: 未知；1：超级管理员（可管理所有项目）；2：管理员（可管理自己维护的项目）；3：项目设计人员（可对某项目下的页面进行管理）；4：普通用户（可对某一项目下的页面进行查看）
    hasMenus: false,
    responseMenus: null,
    permissions: null,
    depts: null,
    appId: null,
  },
  mutations: {
    setUserData(state, data) {
      state.id = data.id
      state.name = data.userName
      state.nameEn = data.userNameEn
      state.userType = data.userType
      state.permissions = data.permissionKeys
      state.depts = data.deptList
      state.appId = data.appId
    },
    setHasMenus(state, has) {
      state.hasMenus = has
    },
    setResponseMenus(state, data) {
      state.responseMenus = data
    },
  },
  actions: {
    login({commit}, data) {
      return loginRequest(data).then(res => {
        if (res.code === 0) {
          const token = res.data.token
          setAccessToken(token)
        }
        return res
      })
    },
    logout({commit}) {
      const token = getAccessToken()
      if (!token?.length) {
        return new Promise((resolve, reject) => {
          resolve()
        })
      }
      return logout().then(res => {
        return res
      }).finally(() => {
        removeAccessToken()
        resetRouter(router)
        commit('setUserData', {})
        commit('setHasMenus', false)
        commit('setResponseMenus', null)
      })
    },
    loginApp({commit}, data) {
      return loginRequest(data).then(res => {
        if (res.code === 0) {
          const token = res.data.token
          const app = data.app
          setAppAccessToken(app, token)
        }
        return res
      })
    },
    logoutApp({commit}, data) {
      const app = data.app
      const token = getAppAccessToken(app)
      if (!token?.length) {
        return new Promise((resolve, reject) => {
          resolve()
        })
      }
      return logout({ app, token }).then(res => {
        return res
      }).finally(() => {
        removeAppAccessToken(app)
      })
    },
    getUserInfo({commit}) {
      return getUserInfo().then(res => {
        if (res.code === 0) {
          commit('setUserData', res.data)
        }
        return res
      })
    },
    getUserMenus({commit}, params) {
      return getUserMenus(params).then(res => {
        if (res.code === 0) {
          const data = JSON.parse(JSON.stringify(res.data))
          addRoutes(data)
          commit('setHasMenus', true)
          commit('setResponseMenus', res.data)
        }
        return res
      })
    },
  }
}